import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { tenderViewComponent } from './tenderView.component';
import { DossierDetailModule } from '../components/dossierDetail.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TableModule } from 'primeng-lts/table';
import { TranslateModule } from '@ngx-translate/core';
import { MainPipes } from '../../pipes/main-pipes-module';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { DocumentFileModule } from '../../documents/documentFile/documentFile.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { tenderListComponent } from './tenderList.component';
import { EnvelopeStatusTableComponent } from './envelopeStatusTable.component';
import { tenderEvaluationComponent } from './tenderEvaluation.component';
import { DialogService, DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { TenderEditorComponent } from './tenderEditor.component';
import { TenderDocumentsComponent } from './tenderDocuments.component';
import { TenderSubmissionsComponent } from './tenderSubmissions.component';
import { TenderEnvelopedDocumentEditorComponent } from './tenderEnvelopedDocumentEditor.component';
import { UploadFilesModule } from '../../components/common/upload/upload.module';
import { TenderCriteriaComponent } from './tender-criteria.component';
import { TenderDocumentDetailComponent } from './tenderDocumentDetail.component';
import { AccordionModule } from 'primeng-lts/accordion';
import { ButtonModule } from 'primeng-lts/button';
import { ChartModule } from 'primeng-lts/chart';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { FieldsetModule } from 'primeng-lts/fieldset';
import { InplaceModule } from 'primeng-lts/inplace';
import { InputMaskModule } from 'primeng-lts/inputmask';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { SliderModule } from 'primeng-lts/slider';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { KeyFilterModule } from 'primeng-lts/keyfilter';
import { RequestedMaterialModule } from '../requestedMaterial/requestedMaterial.module';
import { UnitPricesModule } from '../unitPrices/unitPrices.module';
import { DebounceClickDirective } from '../../directives/debounceClick.directive';
import { DirectivesModule } from '../../directives/directives.module';
@NgModule({
  declarations: [
    tenderViewComponent,
    tenderListComponent,
    EnvelopeStatusTableComponent,
    tenderEvaluationComponent,
    TenderEditorComponent,
    TenderDocumentsComponent,
    TenderSubmissionsComponent,
    TenderEnvelopedDocumentEditorComponent,
    TenderCriteriaComponent,
    TenderDocumentDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,
    DocumentFileModule,

    TableModule,
    TooltipModule,
    ProgressBarModule,
    ToggleButtonModule,
    FormPlycaModule,
    PanelModule,
    TabViewModule,
    CheckboxModule,
    MenuModule,
    OverlayPanelModule,
    SliderModule,
    ChartModule,
    ButtonModule,
    SelectButtonModule,
    InputTextareaModule,
    InputMaskModule,
    MultiSelectModule,
    FieldsetModule,
    DropdownModule,
    TranslateModule,
    InplaceModule,
    MainPipes,
    WaitLoadingModule,
    InputSwitchModule,
    DialogModule,
    DynamicDialogModule,
    SubHeaderModule,
    ScrollPanelModule,
    AccordionModule,
    UploadFilesModule,
    KeyFilterModule,
    RequestedMaterialModule,
    DirectivesModule,
    UnitPricesModule
  ],
  providers: [DialogService],
  exports: [EnvelopeStatusTableComponent]
})
export class TenderViewModule { }
